import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=0d15057b&scoped=true&"
import script from "./Challenge.vue?vue&type=script&lang=ts&"
export * from "./Challenge.vue?vue&type=script&lang=ts&"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=0d15057b&scoped=true&lang=css&"
import style1 from "./Challenge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15057b",
  null
  
)

export default component.exports